import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { SingleResourceShareResponse } from 'types/Share/ResourceShares';

const getResourceShare = (resourceShareID: string | undefined) => {
  if (!resourceShareID) {
    return Promise.reject('something went wrong');
  }

  const url = generateURL(
    SPARK_RESOURCE_TYPES.RESOURCE_SHARES,
    [],
    resourceShareID
  );

  return fetchWrapper<SingleResourceShareResponse>({
    url: url,
    method: 'GET',
  });
};

export function useResourceShareByID(resourceShareID: string | undefined) {
  const queryResult = useQuery(
    [SPARK_RESOURCE_TYPES.RESOURCE_SHARES, resourceShareID],
    () => getResourceShare(resourceShareID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`Failed to get Resource Share: ${error.message}`);
        }
      },
      enabled: Boolean(resourceShareID),
    }
  );

  const { data } = queryResult;
  const { data: resourceShare } = data || {};

  return {
    resourceShare,
    ...queryResult,
  };
}
